export default __webpack_public_path__ + "static/media/PC-Jemla.1b62590a.png";